<template>
  <div>
    <div class="card mb-4">
      <div class="card-header">
        <h5 class="mb-0">Yeni Paylaşım Ekle</h5>
      </div>
      <div class="card-body">
        <form class="row g-2 align-items-center" @submit.prevent="submitPost">
          <div class="col-md-3">
            <select v-model="form.influencerId" class="form-select" required>
              <option value="" disabled>
                Influencer seçiniz
              </option>
              <option v-for="inf in influencers" :key="inf.id" :value="inf.id">
                {{ inf.name }}
              </option>
            </select>
          </div>
          <div class="col-md-2">
            <input v-model="form.postDate" type="date" class="form-control" required>
          </div>
          <div class="col-md-2">
            <input
              v-model.number="form.postCount"
              type="number"
              min="1"
              class="form-control"
              placeholder="Paylaşım adedi *"
              required
            >
          </div>
          <div class="col-md-3">
            <input v-model="form.note" type="text" class="form-control" placeholder="Not">
          </div>
          <div class="col-md-2">
            <button type="submit" class="btn btn-success w-100" :disabled="saving">
              Ekle
            </button>
          </div>
        </form>
        <div v-if="errorMessage" class="text-danger mt-2">
          {{ errorMessage }}
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-header">
        <h5 class="mb-0">Paylaşım Listesi</h5>
      </div>
      <div class="card-body">
        <div class="row g-2 mb-3">
          <div class="col-md-3">
            <select v-model="filters.influencerId" class="form-select" @change="fetchPosts">
              <option value="">
                Tüm Influencerlar
              </option>
              <option v-for="inf in influencers" :key="inf.id" :value="inf.id">
                {{ inf.name }}
              </option>
            </select>
          </div>
          <div class="col-md-2">
            <input v-model="filters.startDate" type="date" class="form-control" @change="fetchPosts">
          </div>
          <div class="col-md-2">
            <input v-model="filters.endDate" type="date" class="form-control" @change="fetchPosts">
          </div>
          <div class="col-md-2">
            <button type="button" class="btn btn-outline-secondary w-100" @click="clearFilters">
              Temizle
            </button>
          </div>
        </div>
        <div v-if="loading">
          Yükleniyor...
        </div>
        <table v-else class="table table-bordered table-hover table-striped">
          <thead class="table-dark">
            <tr>
              <th>Tarih</th>
              <th>Influencer</th>
              <th>Paylaşım Adedi</th>
              <th>Not</th>
              <th />
            </tr>
          </thead>
          <tbody>
            <tr v-for="p in posts" :key="p.id">
              <td>{{ p.postDate }}</td>
              <td>{{ p.influencer ? p.influencer.name : '' }}</td>
              <td>{{ p.postCount }}</td>
              <td>{{ p.note }}</td>
              <td class="text-end">
                <button
                  type="button"
                  class="btn btn-sm btn-outline-danger"
                  :disabled="deletingId === p.id"
                  @click="deletePost(p)"
                >
                  Sil
                </button>
              </td>
            </tr>
            <tr v-if="posts.length === 0">
              <td colspan="5" class="text-center text-muted">
                Kayıt bulunamadı.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfluencerPostTab',
  data() {
    return {
      influencers: [],
      posts: [],
      loading: true,
      saving: false,
      deletingId: null,
      errorMessage: '',
      form: {
        influencerId: '', postDate: '', postCount: null, note: '',
      },
      filters: {
        influencerId: '', startDate: '', endDate: '',
      },
    };
  },
  mounted() {
    this.fetchInfluencers();
    this.fetchPosts();
  },
  methods: {
    fetchInfluencers() {
      this.axios.get(`${this.baseUrl}/influencer`, this.$store.getters.authHeader)
        .then((response) => {
          this.influencers = response.data;
        });
    },
    fetchPosts() {
      this.loading = true;
      const params = {};
      if (this.filters.influencerId) params.influencerId = this.filters.influencerId;
      if (this.filters.startDate) params.startDate = this.filters.startDate;
      if (this.filters.endDate) params.endDate = this.filters.endDate;
      this.axios.get(`${this.baseUrl}/influencer/post`, {
        ...this.$store.getters.authHeader,
        params,
      })
        .then((response) => {
          this.posts = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    clearFilters() {
      this.filters = { influencerId: '', startDate: '', endDate: '' };
      this.fetchPosts();
    },
    submitPost() {
      this.errorMessage = '';
      this.saving = true;
      this.axios.post(`${this.baseUrl}/influencer/post`, this.form, this.$store.getters.authHeader)
        .then(() => {
          this.form = {
            influencerId: '', postDate: '', postCount: null, note: '',
          };
          this.fetchPosts();
        })
        .catch((error) => {
          this.errorMessage = (error.response && error.response.data) || 'Paylaşım eklenirken hata oluştu.';
        })
        .finally(() => {
          this.saving = false;
        });
    },
    deletePost(post) {
      // eslint-disable-next-line no-alert
      if (!window.confirm(`${post.influencer ? post.influencer.name : ''} - ${post.postDate} tarihli paylaşımı silmek istiyor musunuz?`)) {
        return;
      }
      this.deletingId = post.id;
      this.axios.delete(`${this.baseUrl}/influencer/post/${post.id}`, this.$store.getters.authHeader)
        .then(() => {
          this.fetchPosts();
        })
        .catch((error) => {
          this.errorMessage = (error.response && error.response.data) || 'Paylaşım silinirken hata oluştu.';
        })
        .finally(() => {
          this.deletingId = null;
        });
    },
  },
};
</script>

<style scoped>
</style>
